export default __webpack_public_path__ + "css/SalesOrderAdviceNote.bundle.css";